import { render, staticRenderFns } from "./BaseFormTextArea.vue?vue&type=template&id=1d358d4f"
import script from "./BaseFormTextArea.vue?vue&type=script&lang=js"
export * from "./BaseFormTextArea.vue?vue&type=script&lang=js"
import style0 from "./BaseFormTextArea.vue?vue&type=style&index=0&id=1d358d4f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports